<template>
<div class="main_unit menu_center">
  <div class="dashboard_top_unit">
    <div class="mgt_40 mgl_20">
      <Message v-if="apiValidationMessage" :validationMessage="apiValidationMessage" />
    </div>
    <ul>
      <li>
        <div class="top_item">
          <div class="dashboard_criteria_top">
            <div class="dashboard_top_center_box_mgt">集計期間</div>
            <div class="temperature_input_display left_comment mgt_8" id="selectDay">
              <div class="temperature_lavel right_comment form-check-inline mgr_60">
                <label for="selectDay">開始日</label>
              </div>
              <div class="form-check-inline mgl_15">
                <v-date-picker ref="picker" v-model="startDate" mode="single" @input="selectedDay"></v-date-picker>
              </div>
            </div>
            <div class="temperature_input_display left_comment mgt_8" id="selectDay">
              <div class="temperature_lavel right_comment form-check-inline mgr_60">
                <label for="selectDay">終了日</label>
              </div>
              <div class="form-check-inline mgl_15">
                <v-date-picker ref="picker" v-model="endDate" mode="single" @input="selectedDay"></v-date-picker>
              </div>
            </div>
            <div class="mgt_30 mgl_20">
              <Message v-if="!this.addFormFlg" :validationMessage="alertMessage" /><br>
            </div>
            <div class="temperature_input_display left_comment mgt_8" id="displayTime">
              <div class="temperature_lavel right_comment form-check-inline mgr_60">
                <label for="displayTime">表示期間</label>
              </div>
              <div class="form-check form-check-inline wd70">
                <input class="form-check-input display_radio" id="displayTime_id1" name="checkTime" type="radio" value=1 v-model="dayRangeSelectIndex" @change="changeDayRange">
                <label class="form-check-label" for="displayTime_id1">昨日</label>
              </div>
              <div class="form-check form-check-inline wd70">
                <input class="form-check-input display_radio" id="displayTime_id2" name="checkTime" type="radio" value=2 v-model="dayRangeSelectIndex" @change="changeDayRange">
                <label class="form-check-label" for="displayTime_id2">過去7日間</label>
              </div>
              <div class="form-check form-check-inline wd70">
                <input class="form-check-input display_radio" id="displayTime_id3" name="checkTime" type="radio" value=3 v-model="dayRangeSelectIndex" @change="changeDayRange">
                <label class="form-check-label" for="displayTime_id3">過去30日間</label>
              </div>
              <div class="form-check form-check-inline wd70">
                <input class="form-check-input display_radio" id="displayTime_id4" name="checkTime" type="radio" value=4 v-model="dayRangeSelectIndex" @change="changeDayRange">
                <label class="form-check-label" for="displayTime_id4">先月</label>
              </div>
            </div>
            <div class="btn_submit mgt_15 letter_spa">
              <a href="#" @click.prevent.stop="checkFrom">集計</a>
            </div>
          </div>
        </div>
      </li>
      <li>
        <div class="top_item">
          <div class="area_List_tbl_unit wd400 tbl_bg_blue mgb_30" >
            <table>
              <thead>
              <tr class="text-center">
                <th class="wd400 border_bottom_none" style="min-width:240px">集計対象エリア選択</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="area in areaList" :key="area.id" >
                <td class="text_white_space"
                    :class="{'is_active': isActive(area.id, selectedAreaId)}"
                >
                  <a role="button"
                     @click.stop.prevent="areaSelect(area.id)">{{area.areaName}}
                  </a>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="btn_submit mgt_15">
            <a href="#" @click.prevent.stop="cookingHealthCsv" style="width: auto !important;">健康身だしなみ&重要管理項目CSV</a>
          </div>
        </div>
      </li>
    </ul>
  </div>
  <pulse-loader class="w-100 text-center" :loading="isLoading"></pulse-loader>
  <div v-if="showContent" class="details_unit">
    <ul>
      <li v-for="Item in implementedData" :key="Item">
          <div v-if="Item.isExitsDate" class="details_item" :style="getWidth">
            <div class="details_title"><p>{{Item.datasets[0].label}}</p></div>
            <div v-if="!Item.isExitsDate" class="mgt_40 mgl_20">
              <Message :validationMessage="notExistsDateMessage" /><br>
            </div>
            <div  class="implementation_rate_box" @click.stop.prevent="selectedGraph(Item.alertId)">
              <PieChart :chart-data="Item" :options="options" class="pie_box"></PieChart>
            </div>
            <div class="implemented_box">
              <p class="implemented"><img class="implemented" src="../assets/img/Implemented.png" />{{Item.implementedStores}}店舗</p>
              <p class="line"></p>
              <p class="not_implemented"><img class="implemented" src="../assets/img/Not_Implemented.png" />{{Item.notImplementedStores}}店舗</p>
            </div>
          </div>
      </li>
    </ul>
  </div>
</div>
</template>

<script>
  import PieChart from '@/app/components/PieChart.vue'
  import PulseLoader from '@/app/components/PulseLoader.vue'
  import Message from '@/app/components/Message.vue'

export default {
  name: "DashboardMain",
  components: {
    PieChart,
    PulseLoader,
    Message,
  },
  created() {
    // 年月セット
    this.updateAggregationPeriod()
  },
  data: function () {

    return {
      showContent: false,
      brandId: '',
      storeId: '',
      isLoading: false,
      apiValidationMessage: "",
      alertMessage: "",
      notExistsDateMessage: "データが存在しません。",
      addFormFlg: true,
      selectedAreaId: 0,
      areaList: [],
      startDate:null,
      endDate:null,
      month: null,
      year: null,
      next: { year: null, month: null },
      prev: { year: null, month: null },
      //温度湿度管理一覧取得
      implementedData: [],
      options: {
        responsive:true,
        maintainAspectRatio:false,
      },
      routerParams:{},
      dayRangeSelectIndex:0,
      daySelectCount:0,
      width: 256,
    }
  },
  computed: {
    brandPath: function () {
      return this.$store.getters['brand/path']
    },
    getWidth(){
      return{
        width: `${this.width}px !important`
      }
    }
  },
  watch: {
    // ルートが変更されたらこのメソッドを再び呼び出します
    '$route': function () {
      this.updateAggregationPeriod()
    }
  },
  methods: {
    checkFrom: async function() {
      this.addFormFlg = true;
      this.isLoading = true;
      this.alertMessage = '';


      //バリデーションチェック
      //必須チェック
      if(!this.startDate || !this.endDate){
        this.alertMessage="集計期間を指定してください。"
        this.addFormFlg = false;
      }

      // バリデーションチェック
      var selectStartBusinessDay = "";
      var selectEndBusinessDay = "";
      var nowBusinessDay = "";
      // 営業日の未来日付のチェック
      if(this.startDate !== null){
        selectStartBusinessDay = this.selectDateFormat(this.startDate);
        nowBusinessDay = this.chartDateBusinessDay(new Date());
        // 未来の営業日を選択している場合
        if(selectStartBusinessDay > nowBusinessDay){
          this.alertMessage="未来の営業日は選択できません。";
          this.isLoading = false;
          this.addFormFlg = false;
          return ;
        }

        const toDate = new Date();
        toDate.setDate(toDate.getDate()-365);
        const oneYearAgoDate = this.chartDateBusinessDay(toDate);
        if(oneYearAgoDate > selectStartBusinessDay){
          this.alertMessage="1年以上前の営業日は選択できません。";
          this.isLoading = false;
          this.addFormFlg = false;
          return ;
        }
        if(this.endDate !== null) {
          selectEndBusinessDay = this.selectDateFormat(this.endDate);
          nowBusinessDay = this.chartDateBusinessDay(new Date());
          // 未来の営業日を選択している場合
          if(selectEndBusinessDay > nowBusinessDay){
            this.alertMessage="未来の営業日は選択できません。";
            this.isLoading = false;
            this.addFormFlg = false;
            return ;
          }
          // 開始日が終了日より未来を指定している場合
          if(selectStartBusinessDay > selectEndBusinessDay){
            this.alertMessage="開始日は終了日以前を選択してください。";
            this.isLoading = false;
            this.addFormFlg = false;
            return ;
          }
        }
      }

      // バリデーション
      if(this.addFormFlg) {
        await this.dashboardData()
      } else {
        this.isLoading = false;
        return null;
      }
    },
    chartDateBusinessDay(date){

      let year = date.getFullYear();
      let month = ("0" + (date.getMonth()+1)).slice(-2);
      let day = ("0" + date.getDate()).slice(-2);
      let hours = ("0" + date.getHours()).slice(-2);

      // AM00-AM03時の判定
      if(hours >= '00' && hours < '03'){

        // 年始の考慮
        if(month == '01' && day == '01'){
          var yearEndDate = new Date(date.getFullYear()-1,12,0);
          year = date.getFullYear()-1;
          month = 12;
          day = ("0" + yearEndDate.getDate()).slice(-2);

        }
        // 月末の考慮
        else if(day == '01'){
          var monthEndDate = new Date(date.getFullYear(),date.getMonth(),0);
          month = ("0" + (date.getMonth())).slice(-2);
          day = ("0" + monthEndDate.getDate()).slice(-2);
        }
        // 前日日付の営業日
        else{
          var dayBeforeDate = new Date(date.getFullYear(),date.getMonth()+1,date.getDate()-1);
          day =  ("0" + dayBeforeDate.getDate()).slice(-2);
        }
      }

      let format_str = 'YYYY/MM/DD';
      format_str = format_str.replace(/YYYY/g,year);
      format_str = format_str.replace(/MM/g,month);
      format_str = format_str.replace(/DD/g,day);

      return format_str;
    },
    selectDateFormat(date){
      let year = date.getFullYear();
      let month = ("0" + (date.getMonth()+1)).slice(-2);
      let day = ("0" + date.getDate()).slice(-2);

      let format_str = 'YYYY/MM/DD';
      format_str = format_str.replace(/YYYY/g,year);
      format_str = format_str.replace(/MM/g,month);
      format_str = format_str.replace(/DD/g,day);

      return format_str;
    },
    async dashboardData() {
      this.areaList = [
        {
          id:0,
          areaName:"全店舗"
        }
      ];
      this.implementedData = [];
      this.isLoading = true
      this.showContent = false;
      let brandId = this.$store.getters['brand/id'];
      this.validationModelMessage = "";

      const params = {
        start_date: this.selectDateFormat(this.startDate),
        end_date: this.selectDateFormat(this.endDate),
        areaId: this.selectedAreaId
      };

      //更新API呼び出し
      await this.$axios
          .get(this.$apiEndpoint + 'manage/brand/' + brandId + '/dashboard', { params })
          .then(response => {
            this.routerParams = {
              startDate: this.selectDateFormat(this.startDate),
              endDate: this.selectDateFormat(this.endDate),
            };
            if(response['data']['areaList'] !== null) {
              let areas = response['data']['areaList'];
              areas.forEach(area => {
                this.areaList.push(area);
              });
            }
            let temperatureHumiditySensorAccident = response['data']['temperatureHumiditySensorAccidentResponse'];
            let gwConnectionSensorAccident = response['data']['gwConnectionSensorAccidentResponse'];
            let dailyCheck = response['data']['dailyCheckResponse'];
            let irregularityCheck = response['data']['irregularityCheckResponse'];
            if(temperatureHumiditySensorAccident != null) {
              this.dateFormat(temperatureHumiditySensorAccident, ['全異常対応済み','未対応'],'温湿度異常',0)
            }
            if(gwConnectionSensorAccident != null) {
              this.dateFormat(gwConnectionSensorAccident, ['全異常対応済み','未対応'],'通信異常',1)
            }
            if(dailyCheck['checkItem']) {
              this.dateFormat(dailyCheck, ['全チェック済み','未チェック有り'],'A/D 毎日',2)
            }
            if(irregularityCheck['checkItem']) {
              this.dateFormat(irregularityCheck, ['全チェック済み','未チェック有り'],'A/D 不定期',3)
            }
            this.width = 1024/this.implementedData.length;
            this.showContent = true;
          })
          .catch((err) => {
            let error = {
              button: {
                path: {name: 'top', params:{brandPath: this.brandPath}}
              }}
            if (err.customError) {
              error = Object.assign(error, err.customError)
            }
            this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
          }).finally(()=> this.isLoading = false);
    },
    updateAggregationPeriod: function () {
      this.startDate = new Date();
      this.endDate = new Date();
      this.dashboardData()
    },
    areaSelect: function (id) {
      this.selectedAreaId = id
      this.checkFrom()
    },
    isActive: function (row, selectedAreaId) {
      return row == selectedAreaId
    },
    selectedGraph: function (alertId) {
      this.$store.dispatch('dashboard/setAlertId', alertId);
      this.$store.dispatch('dashboard/setAreaId', this.selectedAreaId);
      this.$router.push({name: 'dashboardAlertList', params: this.routerParams});
    },
    cookingHealthCsv: function () {
      this.$store.dispatch('dashboard/setAreaId', this.selectedAreaId);
      this.$router.push({name: 'dashboardCookingHealthListIndex', params: this.routerParams});
    },
    changeDayRange: function () {

      this.startDate = new Date();
      this.endDate = new Date();
      var now = new Date();
      var dayRangeSelectNum = Number(this.dayRangeSelectIndex);
      switch(dayRangeSelectNum){
        case 1:
          // 昨日
          this.startDate.setDate(now.getDate()-1);
          this.endDate.setDate(now.getDate()-1);
          break;
        case 2:
          // 過去７日間
          this.startDate.setDate(now.getDate()-7);

          break;
        case 3:
          // 過去３０日間
          this.startDate.setDate(now.getDate()-30);

          break;
        case 4:
          // 先月
          this.startDate = new Date(now.getFullYear(), now.getMonth() - 1, 1);
          this.endDate = new Date(now.getFullYear(),now.getMonth(),0);
          break;

      }
      this.daySelectCount = 0;
    },
    selectedDay: function () {
      this.daySelectCount += 1;
      if(this.daySelectCount == 3) {
        this.dayRangeSelectIndex = 0;
        this.daySelectCount = 0;
      }
    },
    dateFormat: function (result, labels, title,alertId){
      var date = {
        labels: labels,
        datasets:[
          {
            label:title,
            backgroundColor: ['#4472C4', '#ED7D31'],
            data: [
                  result['implementedRate'],
                  result['notImplementedRate']
            ],
          }
          ],
        implementedStores: result['implementedStores'],
        notImplementedStores: result['notImplementedStores'],
        isExitsDate: true,
        alertId:alertId,
      };
      this.implementedData.push(date);
    },
  }
}
</script>